module.exports = __webpack_public_path__ + "static/media/data-bar.ad17544b.png";